module.exports = __webpack_public_path__ + "static/fonts/Fact-Italic.665c356.woff";